export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-bca9781bfa6fb598df5a4b99faefa05d.woff";